import Icon from '../components/Icon.vue'

Icon.register({
  spinner: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M304 48C304 74.5 282.5 96 256 96S208 74.5 208 48 229.5 0 256 0 304 21.5 304 48zM256 416C229.5 416 208 437.5 208 464S229.5 512 256 512 304 490.5 304 464 282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256S437.5 304 464 304 512 282.5 512 256 490.5 208 464 208zM96 256C96 229.5 74.5 208 48 208S0 229.5 0 256 21.5 304 48 304 96 282.5 96 256zM108.9 355.1C82.4 355.1 60.9 376.6 60.9 403.1S82.4 451.1 108.9 451.1 156.9 429.6 156.9 403.1C156.9 376.6 135.4 355.1 108.9 355.1zM403.1 355.1C376.6 355.1 355.1 376.6 355.1 403.1S376.6 451.1 403.1 451.1 451.1 429.6 451.1 403.1C451.1 376.6 429.6 355.1 403.1 355.1zM108.9 60.9C82.4 60.9 60.9 82.4 60.9 108.9S82.4 156.9 108.9 156.9 156.9 135.4 156.9 108.9 135.4 60.9 108.9 60.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/spinner.js
// module id = epX/
// module chunks = 144